import { Col, Container, Row } from "react-bootstrap";
import { useState } from "react";
import Boton from "../Boton/Boton";
import ModalMarca from "../ModalMarca/ModalMarca";
import { FaWhatsapp } from "react-icons/fa";
import logos from "../../assets/img/consultas/logos.png";
import logoMontironi from "../../assets/img/logo.png";
import { openInNewTab } from "../Utils/utils";

const SORTEO_TYC_URL = "https://www.montironi.com/pdf/bases-y-condiciones-sorteo.pdf";
// Mundial 2026 finaliza el 19/07/2026; ocultar el link una semana después
const SORTEO_TYC_HIDE_DATE = new Date(2026, 6, 27);

const showSorteoTyC = () => new Date() < SORTEO_TYC_HIDE_DATE;

const Main = ({ marca, listado, title }) => {
  const [showModal, setShowModal] = useState(false);
  const [tipoConsulta, setTipoConsulta] = useState("");

  const handleOpenModal = (tipo) => {
    setTipoConsulta(tipo);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setTipoConsulta("");
  };

  return (
    <Container>
      <Row>
        <Col
          md={6}
          xs={12}
          className="mx-auto d-flex flex-column justify-content-center align-content-center align-items-center w-100"
        >
          <img src={logoMontironi} alt="Logo Montironi" className="mb-4 mt-3" />

          <h1 className="h1-linktree pt-5">¡Elegí cómo querés llegar a tu nuevo auto!</h1>

          <h5 className="h5-linktree pb-4 pt-4 text-start w-100">
            <b>Tu auto nuevo con entrega inmediata.</b>
          </h5>

          <Boton
            title={"Consultá por tu próximo 0km"}
            callback={() => handleOpenModal("0km")}
            icon={<FaWhatsapp />}
            style={"usados"}
            size={20}
          />

          <hr style={{ border: "1px solid #FFF", width: "100%" }}></hr>

          <h5 className="h5-linktree pb-4 pt-4  text-start w-100">
            Tu auto en <b>cuotas y con adjudicación pactada.</b>
          </h5>

          <Boton
            title={"Conocé los planes disponibles"}
            callback={() => handleOpenModal("plan")}
            icon={<FaWhatsapp />}
            style={"usados"}
            size={20}
          />

          <img src={logos} alt="Logos" className="mt-5" />

          {showSorteoTyC() && (
            <button
              type="button"
              className="sorteo-tyc-link mt-3 mb-3"
              onClick={() => openInNewTab(SORTEO_TYC_URL)}
            >
              TyC Sorteo Mundial 2026
            </button>
          )}
        </Col>
      </Row>

      <ModalMarca show={showModal} onHide={handleCloseModal} tipoConsulta={tipoConsulta} />
    </Container>
  );
};

export default Main;
